<template>
  <div id="app">
    <vue-progress-bar></vue-progress-bar>
    <main-header></main-header>
    <main-sidebar class="content-margin">
      <router-view></router-view>
    </main-sidebar>
    <!-- <main-footer v-if="usuarioLogado.id"></main-footer> -->
  </div>
</template>

<script>
import MainHeader from './components/MainHeader.vue'
import MainSidebar from './components/MainSidebar.vue'
import MainFooter from './components/MainFooter.vue'

export default {
  name: 'app',
  components: {
    MainHeader,
    MainSidebar,
    MainFooter
  },
  mounted() {
    this.onElementHeightChange(document.body, () => {
      let bodyHeight = document.querySelector('body').clientHeight
      document.querySelector('.main-sidebar').style.height = `${bodyHeight}px`
    })
  },
  methods: {
    onElementHeightChange(elm, callback) {
      let lastHeight = elm.clientHeight
      let newHeight
      ;(function run() {
        newHeight = elm.clientHeight
        if (lastHeight !== newHeight) {
          callback()
        }
        lastHeight = newHeight
        if (elm.onElementHeightChangeTimer) {
          clearTimeout(elm.onElementHeightChangeTimer)
        }
        elm.onElementHeightChangeTimer = setTimeout(run, 200)
      })()
    }
  },
  computed: {
    usuarioLogado() {
      return this.$store.getters.getUser
    }
  }
}
</script>

<style>
@import url('../node_modules/typeface-roboto/index.css');

body {
  font-family: roboto;
}

@media only screen and (min-width: 1400px) {
  .content-margin {
    margin-top: 40px;
  }
}

@media print {
  .content-margin {
    margin-top: unset !important;
  }
  title {
    visibility: hidden;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.adaptative-col {
  padding: 0px 5px;
}
.in-line {
  display: flex;
  flex-direction: row;
  flex-flow: wrap;
}

@media screen and (max-width: 1250px) {
  .adaptative-col {
    width: 100%;
  }
  .in-line {
    flex-direction: column;
  }
}
</style>
